const obj={
    INF04: {
        2022: {
           "inf04_2022_czerwiec_1": [{name: "domek w górach", lang: "mobilna", desc: "", year: "2022", month: "czerwiec"}],
            "inf04_2022_czerwiec_2": [{name: "kursy", lang: "web", desc: "", year: "2022", month: "czerwiec"}],
            "inf04_2022_styczen_1": [{name: "rejestruj konto", lang: "moblina", desc: "", year: "2022", month: "styczen"}]
        },
        2023:{
            "inf04_2023_czerwiec_1": [{name: "nadaj przesyłkę", lang: "desktopowa", desc: "", year: "2023", month: "czerwiec"}],
            "inf04_2023_czerwiec_2": [{name: "własności czcionki", lang: "moblina", desc: "", year: "2023", month: "czerwiec"}],
            "inf04_2023_czerwiec_3": [{name: "filmy", lang: "web", desc: "", year: "2023", month: "czerwiec"}],
            "inf04_2023_styczen_1": [{name: "dodaj pracownika", lang: "desktopowa", desc: "", year: "2023", month: "styczen"}],
            "inf04_2023_styczen_2": [{name: "lista zakupów", lang: "moblina", desc: "", year: "2023", month: "styczen"}]
        },
        2024:{
            "inf04_2024_styczen_1": [{name: "paszport", lang: "desktopowa", desc: "", year: "2024", month: "styczen"}],
            "inf04_2024_styczen_2": [{name: "weterynarz", lang: "moblina", desc: "", year: "2024", month: "styczen"}]
        }
        
    }
    
}

export default obj